
export default {
  name: 'Characteristics',

  props: {
    characteristics: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    getCharacteristics() {
      const list = [];
      const char = this.characteristics;

      char.forEach((t) => {
        t.characteristics
          .filter((t) => Boolean(t.id !== 56))
          .forEach((d) => {
            const charString = [];

            if (d.showInProduct) {
              d?.values.forEach((item) => {
                charString.push(item?.value || '');
              });

              list.push({
                id: d.id,
                unit: d.unit,
                name: d.name,
                value: charString,
              });
            }
          });
      });
      return list;
    },
  },
};
